import { createContext } from "react";
import { itemListData } from "../../../../../../../../common/TableData";

interface ISubAffDealsContextContext {
  selectedRow: itemListData | null,
  setSelectedRow: (data: itemListData | null) => void;
}

export const SubAffDealsContext = createContext<ISubAffDealsContextContext>({
  selectedRow: null,
  setSelectedRow: () => {},
});


